import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  PRIMARY_OUTLET,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import { generateGuid, isNil, Nillable } from '@web/utils';
import { BreadcrumbService } from '../services/breadcrumb.service';
import { TitleService } from '../services/title.service';
import { RouterLink } from '../types/router-link';
import { Breadcrumb } from '../models/breadcrumb';

@Injectable({
  providedIn: 'root',
})
export class CustomTitleStrategy extends TitleStrategy {
  private readonly pageTitle = inject(TitleService);
  private readonly breadcrumb = inject(BreadcrumbService);

  public updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    const breadcrumbs = this.buildBreadcrumbs(snapshot);

    this.updateBreadcrumbs(breadcrumbs);

    if (isNil(title)) {
      return;
    }

    this.updatePageTitle(title);
  }

  private updatePageTitle(title: string): void {
    this.pageTitle.setTitle(title);
  }

  private buildBreadcrumbs(snapshot: RouterStateSnapshot): Breadcrumb[] {
    let route: Nillable<ActivatedRouteSnapshot> = snapshot.root;
    let label = undefined;
    const routerLink: RouterLink = ['/'];
    const breadcrumbs: Breadcrumb[] = [];

    while (!isNil(route)) {
      label = this.getResolvedTitleForRoute(route) ?? null;
      const id = generateGuid();

      if (!isNil(label)) {
        breadcrumbs.push(new Breadcrumb(id, label, [...routerLink]));
      }

      route.children.forEach((child) => {
        const fragments = child.url.map((segment) => segment.path);

        routerLink.push(...fragments);
      });

      route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
    }

    return breadcrumbs;
  }

  private updateBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
    this.breadcrumb.setBreadcrumbs(breadcrumbs);
  }
}
